import React, { useEffect, useState } from 'react'

import CampaignPage from '../../index'
import ClientQuestionsView from '../component/ClientQuestionsView'

import { DropzoneWithUrl } from '../../../../../Components/Form/DropzoneWithUrl'
import { apiClient } from '../../../../../Module/API/Client'
import QuizQuestionsForm from '../../../../../Components/QuizQuestionsForm/container/QuizQuestionsForm'
import { getQuiz, setQuiz, updateQuiz } from '../../../../../Module/graphQL'
import { QUIZ_TYPES } from '../../../../../shared/constants'

import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'

const ClientQuestions = ({ match, nav, history }) => {
  const [progress, setProgress] = useState(null)
  const [quizData, setQuizData] = useState({})
  const [quizUpdating, setQuizUpdating] = useState(false)
  const [pitchUrl, setPitchUrl] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [quizQuestions, setQuizQuestions] = useState([])

  const { campaignId } = match.params

  const fetchArgs = {
    type: QUIZ_TYPES.CLIENT_PITCH,
    campaignId,
  }

  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getQuiz,
    defaultFetchArgs: fetchArgs,
    fetchId: 'getQuiz',
    mapResponse: data => data.quiz,
  })

  const refetchQuiz = async () => {
    refetch(fetchArgs)
  }

  useEffect(() => {
    if (isLoaded) {
      const url = data.url
      const questions = data.quizQuestions || []
      setQuizQuestions(questions)
      if (url) {
        setPitchUrl(url)
      }
      setQuizData(data)
    }
  }, [isLoaded])

  const onChange = async ([pitchFile]) => {
    setProgress(20)
    const pitchUrl = await apiClient.uploadPitchFile(campaignId, pitchFile)
    setProgress(75)
    const response = await setQuiz({
      type: QUIZ_TYPES.CLIENT_PITCH,
      campaignId,
      url: pitchUrl,
    })
    const result = await response.json()
    if (result.errors && result.errors[0])
      throw new Error(result.errors[0].message)
    setProgress(100)
    setPitchUrl(pitchUrl)
    setProgress(null)
  }

  const onDelete = async () => {
    setIsDeleting(true)
    const response = await setQuiz({
      type: QUIZ_TYPES.CLIENT_PITCH,
      campaignId,
      url: null,
    })
    const result = await response.json()
    if (result.errors && result.errors[0])
      throw new Error(result.errors[0].message)
    setPitchUrl(null)
    setIsDeleting(false)
  }

  const enforceQuizResultWeeklyTermination = async () => {
    setQuizUpdating(true)
    const response = await updateQuiz({
      id: data.id,
      weekly: !data.weekly,
    })
    const result = await response.json()
    const {
      data: {
        updateQuiz: { success },
      },
    } = result

    if (success) {
      setQuizUpdating(false)
      setQuizData({
        ...quizData,
        weekly: !quizData.weekly,
      })
    }
    setQuizUpdating(false)
    return
  }

  return (
    <CampaignPage
      active={nav}
      history={history}
      match={match}
      campaignId={campaignId}
    >
      <ClientQuestionsView
        pitchUrl={pitchUrl}
        onDelete={onDelete}
        onEnforceQuizResultWeeklyTermination={
          enforceQuizResultWeeklyTermination
        }
        quizData={quizData}
        quizUpdating={quizUpdating}
        isDeleting={isDeleting}
        fileUploader={
          <DropzoneWithUrl
            progress={progress}
            input={{ onChange }}
            meta={{}}
            src={pitchUrl}
          />
        }
      >
        {pitchUrl && (
          <QuizQuestionsForm
            campaignId={campaignId}
            fetchQuizQuestions={refetchQuiz}
            quizQuestions={quizQuestions}
          />
        )}
      </ClientQuestionsView>
    </CampaignPage>
  )
}

export default ClientQuestions
